/**
 * @author Christine Movius
 * @desc multisite section component for global use
 * @example <multisite-section
 *              website-hierarchy="$ctrl.websiteHierarchy"
 *              param-type="$ctrl.paramType"
 *              render-checkbox="$ctrl.renderCheckbox"
 *              selected-sections="$ctrl.selectedSections"
 *              website-section="$ctrl.websiteSection"
 *              on-change-selected-sections="$ctrl.onChangeSelectedSections(websiteSectionArr)">
 *          </multisite-section>
*/

import template from './multisiteSection.html';

class multisiteSectionController {
  constructor(
    filtersService,
  ) {
    this.filtersService = filtersService;
  }

  $onInit() {
    this.isExpanded = false;

    if (this.websiteSection) {
      this.hasChildren = this.websiteSection.children && this.websiteSection.children.length;
      if (this.paramType && !this.renderCheckbox) {
        const linkConfig = {};
        linkConfig[this.paramType] = this.websiteSection._id;

        this.queryParams = {
          ...this.filtersService.defaultFilters,
          ...linkConfig
        };
      }
    }
  }

  $onChanges() {
    if (this.renderCheckbox) {
      this.isChecked = this.selectedSections.indexOf(this.websiteSection._id) > -1;
      if (this.websiteSection.ancestors &&
          this.websiteSection.ancestors[this.websiteHierarchy] &&
          this.websiteSection.ancestors[this.websiteHierarchy].length) {
        let isDisabledCount = 0;

        this.websiteSection.ancestors[this.websiteHierarchy].forEach((ancestor) => {
          if (this.selectedSections.indexOf(ancestor) > -1) {
            isDisabledCount += 1;
          }
        });

        this.isDisabled = !!isDisabledCount;

        if (this.isDisabled && this.selectedSections.indexOf(this.websiteSection._id) > -1) {
          this.onChangeSelectedSections({ websiteSectionArr: [this.websiteSection] });
          this.isChecked = false;
        }
      }
    }
  }

  toggleExpansion() {
    this.isExpanded = !this.isExpanded;
  }
}

multisiteSectionController.$inject = ['filtersService', 'featureFlag'];

const multisiteSection = {
  controller: multisiteSectionController,
  template,
  bindings: {
    websiteHierarchy: '<',
    paramType: '<',
    renderCheckbox: '<',
    selectedSections: '<',
    websiteSection: '<',
    onChangeSelectedSections: '&'
  }
};

export default function (ngModule) {
  ngModule.component('multisiteSection', multisiteSection);
  ngModule.controller('multisiteSectionController', multisiteSectionController);
}
